import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'ricerca-models',
  templateUrl: './ricerca-models.component.html',
  styleUrls: ['./ricerca-models.component.scss']
})
export class RicercaModelsComponent implements OnInit {
  @Input() search: any;
  @Output() searchChange = new EventEmitter();

  constructor(
    private fb: FormBuilder,

  ) { }

  formRicerca: FormGroup;

  ngOnInit(): void { 
    this.formRicerca = this.fb.group({
      compagnia: [this.search?.compagnia],
      cod_modello: [this.search?.cod_modello],
      nome_condizione: [this.search?.nome_condizione],
      edizione: [this.search?.edizione],
    });

    this.formRicerca.valueChanges.subscribe(() => this.searchChange.emit(this.formRicerca.value));

  }

}
